<template>
  <v-btn
    :color="buttonColor"
    :loading="loading"
    :disabled="disabled"
    :class="{ 'status-animation': showStatus }"
    @click="handleClick"
  >
    <v-icon v-if="showStatus">
      {{ statusIcon }}
    </v-icon>
    <template v-else>
      <slot>{{ text }}</slot>
    </template>
  </v-btn>
</template>

<script>
export default {
  name: "AnimatedSuccessButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Apply",
    },
    duration: {
      type: Number,
      default: 2000,
    },
    success: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showStatus: false,
      buttonColor: "primary",
    };
  },
  computed: {
    statusIcon() {
      return this.success ? "mdi-check" : "mdi-close";
    },
  },
  watch: {
    loading(newValue) {
      if (!newValue) {
        // When loading becomes false
        this.showStatusState();
      }
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
    showStatusState() {
      this.showStatus = true;
      this.buttonColor = this.success ? "success" : "error";

      setTimeout(() => {
        this.showStatus = false;
        this.buttonColor = "primary";
      }, this.duration);
    },
  },
};
</script>

<style scoped>
.status-animation {
  transition: background-color 1s ease;
}

.v-btn {
  min-width: 100px; /* Adjust this value based on your needs */
  width: 100px; /* Fixed width */
  height: 36px; /* Standard v-btn height, adjust if needed */
}
</style>
